import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "product/group"

class service {

    selectList(params) {
        return http.list(path + "/selectList",params);
    }

    getForceReadById(id){
        return http.getById(path,id,true).then(response => response.data);
    }

    getGroupProductsByFamilyProductId(familyProductId) {

        if (familyProductId > 0) {

            let params = new URLSearchParams()
            params.set("grouped", "true")
            params.set("familyProductId", familyProductId)
            return this.selectList(params)

        }
    }

    getGroupProduct(groupProductId) {

        if (groupProductId > 0) {

            let params = new URLSearchParams()
            params.set("grouped", "true")
            params.set("groupProductId", groupProductId)
            //return http.get(path+)

        }
    }

}

export default new service();

